@if (carregando) {
  <div class="d-flex justify-content-center align-items-center loader" [@esvanecerDesvanecer]="'in'">
    <div class="loader_conteudo">
      <img src="assets/loader.gif" alt="Loader" />

      @if (mensagem != null && mensagem != "") {
        <div class="loader_mensagem">{{ mensagem }}</div>
      }
    </div>
  </div>
}
